import { advanceStateSession } from '@/utils/uiSession'

// UI state only; the service type CRUD actions live with the rest of the service type
// actions in src/store/views/queueSetting/index.js.
//
// `session` is the UI SESSION, in state because the COMPONENT closes this dialog after awaiting
// the create — see utils/uiSession.js and bookingProfileDialog.
export default {
  state: {
    visibility: false,
    session: 0
  },
  mutations: {
    SET_NEW_SERVICE_TYPE_DIALOG_VISIBILITY(state, payload) {
      showDialog(state, payload)
    }
  }
}

function showDialog(state, visible) {
  state.visibility = visible
  advanceStateSession(state)
}
